// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1r22I","rightAdornment":"Header_rightAdornment__3_SYk"};